<template>
	<div class="info-toggle-group">
		<Button :class="['toggle', buttonClass]" v-bind="$attrs" :action="showInfoPopup">
			<slot></slot>
		</Button>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Button from "@/components/base/Button";

export default {
	name: 'InfoPopupToggle',
	components: {
		Button,
	},
	props: {
		activeComponent: {
			type: String,
			required: true,
		},
		buttonClass: {
			type: String,
			required: true,
		},
	},
	computed: {
		...mapState("global/modal", {
			componentName: (state) => state.component,
			isActive: (state) => state.active,
			data: (state) => state.data,
		}),
	},
	methods: {
		...mapActions({
			activateModal: "global/modal/activate",
		}),
		showInfoPopup() {
			this.activateModal({
				component: this.activeComponent,
				data: this.$attrs,
			});
			this.$store.dispatch("sound/fx/play", { id: "button_affirmative" });
		},
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/base/InfoPopupToggle.vue